export default __webpack_public_path__ + "static/media/kafka-logstash-in-action.2a3e0f21.gif";